module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB5SURBVDhPYyARMBkaGgYZAQGUTxwIDQ1lBupZDsSpQLwIiJWhUvgBTKOxsfF/IL0PSPcDsQZUGjdA1gjF/4D8Aqg0bjCqEQ+gv0YQACqcQ5ZGoGIuIN4ExC9J0ggCwITuAdS0HWpABlSYOKCnpydmZmamCOWSABgYAKMnYTXgXUSxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/edit_icon.png
// module id = 49
// module chunks = 0